export default {
  object: {
    showPartner: false,
    faqNote: {
      visible: false,
    },
  },
};
